import { useVariant } from '../context/VariantContext';

export default function FraudStats() {
  const { fraudStats } = useVariant();
  if (!fraudStats) return null;

  return (
    <section className="lp__fraudstats" id="fraudstats">
      <p className="lp__fraudstats-en">{fraudStats.en}</p>
      <h2 className="lp__fraudstats-heading">
        {fraudStats.heading.map((line, i) => (
          <span key={i}>{i > 0 && <br />}{line}</span>
        ))}
      </h2>

      <div className="lp__fraudstats-cards">
        {fraudStats.stats.map((stat) => (
          <div
            className={`lp__fraudstats-card${stat.emphasis ? ' lp__fraudstats-card--emphasis' : ''}`}
            key={stat.label}
          >
            <p className="lp__fraudstats-card__value">{stat.value}</p>
            <p className="lp__fraudstats-card__label">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="lp__fraudstats-senior">
        <p className="lp__fraudstats-senior__text">{fraudStats.seniorNote}</p>
      </div>

      <div className="lp__fraudstats-comparison">
        <p className="lp__fraudstats-comparison__heading">{fraudStats.comparisonHeading}</p>

        <div className="lp__fraudstats-chart">
          <div className="lp__fraudstats-chart__damage">
            <span className="lp__fraudstats-chart__damage-value">{fraudStats.chartDamageValue}</span>
            <span className="lp__fraudstats-chart__damage-label">{fraudStats.chartDamageLabel}</span>
          </div>
          <div className="lp__fraudstats-chart__tappu">
            <span className="lp__fraudstats-chart__tappu-dot" />
            <span className="lp__fraudstats-chart__tappu-value">{fraudStats.chartTappuValue}</span>
            <span className="lp__fraudstats-chart__tappu-label">{fraudStats.chartTappuLabel}</span>
          </div>
        </div>

        <p className="lp__fraudstats-comparison__ratio">{fraudStats.ratioValue}</p>
        <p className="lp__fraudstats-comparison__ratio-note">{fraudStats.ratioNote}</p>
      </div>

      <p className="lp__fraudstats-source">{fraudStats.source}</p>
    </section>
  );
}
